import { useCallback } from 'react'
import { Grid } from '@mui/material'
import {
  BooleanInput,
  SelectInput,
  SimpleForm,
  TextInput,
  // required,
  useEditContext,
  TransformData,
} from 'react-admin'
import {
  COMMON_FIELDS,
  PRODUCTS_COMMON_FIELDS,
  PRODUCTS_BATTERY_FIELDS,
} from '../../providers/localization/constant'
import { EditBase } from '../../components/base'
import { CARD_PROMOTION_FIELDS } from '../../constants/products'
import { parseKeepEmpty } from '../../utils/form'
import { FormBottomToolbarWithPermission } from '../../components/form'
import { ImageInput } from '../../components/inputs'
import { ImageField } from '../../components/fields'
import trim from 'lodash/trim'

const EditForm = (): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { isLoading, record } = useEditContext()
  if (isLoading) return null

  const GridBreak = (): JSX.Element => <div style={{ width: '100%' }}></div>
  return (
    <SimpleForm toolbar={<FormBottomToolbarWithPermission showDeleteButton={false} />}>
      <Grid container spacing={1}>
        {/* row 1 */}
        <Grid item xs={6}>
          <TextInput
            source='prod_name_th'
            label={`${PRODUCTS_COMMON_FIELDS}.prod_name_th.label`}
            fullWidth
            // validate={[required()]}
            disabled
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='prod_name_en'
            label={`${PRODUCTS_COMMON_FIELDS}.prod_name_en.label`}
            fullWidth
            // validate={[required()]}
            disabled
          />
        </Grid>
        {/* row 2 */}
        <Grid item xs={12}>
          <TextInput
            source='prod_desc_th'
            label={`${PRODUCTS_COMMON_FIELDS}.prod_desc_th.label`}
            fullWidth
            // validate={[required()]}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            source='prod_desc_en'
            label={`${PRODUCTS_COMMON_FIELDS}.prod_desc_en.label`}
            fullWidth
            // validate={[required()]}
          />
        </Grid>
        {/* row 3 */}

        {/* row 4 */}
        <Grid item xs={4}>
          <TextInput
            source='prod_brand_name'
            label={`${PRODUCTS_COMMON_FIELDS}.prod_brand_name.label`}
            fullWidth
            // validate={[required()]}
            disabled
          />
        </Grid>
        <Grid item xs={4}>
          <TextInput
            source='prod_brand_code'
            label={`${PRODUCTS_COMMON_FIELDS}.prod_brand_code.label`}
            fullWidth
            // validate={[required()]}
            disabled
          />
        </Grid>
        <Grid item xs={4}>
          <TextInput
            source='prod_model_name'
            label={`${PRODUCTS_COMMON_FIELDS}.prod_model_name.label`}
            fullWidth
            // validate={[required()]}
            disabled
          />
        </Grid>
        {/* row 5 */}
        <Grid item xs={4}>
          <TextInput
            source='prod_type'
            label={`${PRODUCTS_BATTERY_FIELDS}.prod_type.label`}
            fullWidth
            // validate={[required()]}
            disabled
          />
        </Grid>
        <Grid item xs={4}>
          <TextInput
            source='batt_amp'
            label={`${PRODUCTS_COMMON_FIELDS}.batt_amp.label`}
            fullWidth
            // validate={[required()]}
          />
        </Grid>
        <Grid item xs={4}>
          <TextInput
            source='batt_car_type'
            label={`${PRODUCTS_COMMON_FIELDS}.batt_car_type.label`}
            fullWidth
            // validate={[required()]}
          />
        </Grid>
        {/* row 6 */}

        {/* row 7 */}

        {/* row 8 */}
        <Grid item xs={4}>
          <TextInput
            source='prod_size'
            label={`${PRODUCTS_COMMON_FIELDS}.prod_size.label`}
            fullWidth
            // validate={[required()]}
            disabled
          />
        </Grid>
        <Grid item xs={4}>
          <TextInput
            source='prod_size_unit_th'
            label={`${PRODUCTS_COMMON_FIELDS}.prod_size_unit_th.label`}
            fullWidth
            // validate={[required()]}
            disabled
          />
        </Grid>
        <Grid item xs={4}>
          <TextInput
            source='prod_size_unit_en'
            label={`${PRODUCTS_COMMON_FIELDS}.prod_size_unit_en.label`}
            fullWidth
            // validate={[required()]}
            disabled
          />
        </Grid>
        {/* row 9 */}
        <Grid item xs={4}>
          <TextInput
            source='sale_price'
            label={`${PRODUCTS_COMMON_FIELDS}.sale_price.label`}
            fullWidth
            // validate={[required()]}
            disabled
          />
        </Grid>
        <Grid item xs={8}>
          <TextInput
            source='price_remark'
            label={`${PRODUCTS_COMMON_FIELDS}.price_remark.label`}
            fullWidth
            // validate={[required()]}
          />
        </Grid>
        {/* row 10 */}
        <Grid item xs={4}>
          <TextInput
            source='promotion_sale_price'
            label={`${PRODUCTS_COMMON_FIELDS}.promotion_sale_price.label`}
            fullWidth
            parse={parseKeepEmpty}
            // validate={[required()]}
          />
        </Grid>
        <Grid item xs={8}>
          <TextInput
            source='promotion_remark'
            label={`${PRODUCTS_COMMON_FIELDS}.promotion_remark.label`}
            fullWidth
            parse={parseKeepEmpty}
            // validate={[required()]}
          />
        </Grid>
        {/* row 11 */}
        <Grid item xs={4}>
          <TextInput
            source='green_card_promotion_sale_price'
            label={`${PRODUCTS_COMMON_FIELDS}.green_card_promotion_sale_price.label`}
            fullWidth
            parse={parseKeepEmpty}
            // validate={[required()]}
          />
        </Grid>
        <Grid item xs={8}>
          <TextInput
            source='green_card_promotion_remark'
            label={`${PRODUCTS_COMMON_FIELDS}.green_card_promotion_remark.label`}
            fullWidth
            parse={parseKeepEmpty}
            // validate={[required()]}
          />
        </Grid>
        <Grid item xs={4}>
          <TextInput
            source='ev_card_promotion_sale_price'
            label={`${PRODUCTS_COMMON_FIELDS}.ev_card_promotion_sale_price.label`}
            fullWidth
            parse={parseKeepEmpty}
            // validate={[required()]}
          />
        </Grid>
        <Grid item xs={8}>
          <TextInput
            source='ev_card_promotion_remark'
            label={`${PRODUCTS_COMMON_FIELDS}.ev_card_promotion_remark.label`}
            fullWidth
            parse={parseKeepEmpty}
            // validate={[required()]}
          />
        </Grid>
        {/* row 12 */}

        {/* row 13 */}

        <Grid item xs={8}>
          <TextInput
            source='video_url'
            label={`${PRODUCTS_COMMON_FIELDS}.video_url.label`}
            fullWidth
            // validate={[required()]}
          />
        </Grid>
        <GridBreak />
        {/* row 14 */}

        {/* row 15 */}

        {/* row 16 */}
        <Grid item xs={4}>
          <SelectInput
            label={`${PRODUCTS_COMMON_FIELDS}.prod_item_status.label`}
            source='prod_item_status'
            fullWidth
            choices={[
              { id: 'N', name: `${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.N` },
              { id: 'D', name: `${PRODUCTS_COMMON_FIELDS}.prod_item_status.choices.D` },
            ]}
            disabled
          />
        </Grid>
        <Grid item xs={4}>
          <SelectInput
            label={`${PRODUCTS_COMMON_FIELDS}.special_flag.label`}
            source='special_flag'
            fullWidth
            choices={[
              { id: 'P', name: `${PRODUCTS_COMMON_FIELDS}.special_flag.choices.P` },
              { id: 'B', name: `${PRODUCTS_COMMON_FIELDS}.special_flag.choices.B` },
              { id: 'H', name: `${PRODUCTS_COMMON_FIELDS}.special_flag.choices.H` },
            ]}
          />
        </Grid>
        <GridBreak />
        <Grid item xs={4}>
          <TextInput
            source='slug_th'
            label={`${PRODUCTS_COMMON_FIELDS}.slug_th.label`}
            fullWidth
            // validate={[required()]}
          />
        </Grid>
        <Grid item xs={4}>
          <TextInput
            source='slug_en'
            label={`${PRODUCTS_COMMON_FIELDS}.slug_en.label`}
            fullWidth
            // validate={[required()]}
          />
        </Grid>
        {/* row 17 */}
        <Grid item xs={6}>
          <ImageInput
            source='image'
            label={`${PRODUCTS_COMMON_FIELDS}.image.label`}
            accept='image/jpg,image/jpeg,image/png,image/webp'
            // validate={[required()]}
            fallbackSource='full_path'
            initCrop={false}
            fullWidth
          >
            <ImageField source='src' title='title' />
          </ImageInput>
        </Grid>
        <Grid item xs={6}>
          <ImageInput
            source='thumbnail'
            label={`${PRODUCTS_COMMON_FIELDS}.thumbnail.label`}
            accept='image/jpg,image/jpeg,image/png,image/webp'
            // validate={[required()]}
            fallbackSource='full_path'
            initCrop={false}
            fullWidth
          >
            <ImageField source='src' title='title' />
          </ImageInput>
        </Grid>
        <Grid item xs={6}>
          <ImageInput
            source='detail_image'
            label={`${PRODUCTS_COMMON_FIELDS}.detail_image.label`}
            accept='image/jpg,image/jpeg,image/png,image/webp'
            // validate={[required()]}
            fallbackSource='full_path'
            initCrop={false}
            fullWidth
          >
            <ImageField source='src' title='title' />
          </ImageInput>
        </Grid>
        <Grid item xs={6}>
          <ImageInput
            source='warranty_image'
            label={`${PRODUCTS_COMMON_FIELDS}.warranty_image.label`}
            accept='image/jpg,image/jpeg,image/png,image/webp'
            // validate={[required()]}
            fallbackSource='full_path'
            initCrop={false}
            fullWidth
            requiredImage={false}
          >
            <ImageField source='src' title='title' />
          </ImageInput>
        </Grid>
      </Grid>
      <BooleanInput
        color='primary'
        source='is_highlight'
        label={`${PRODUCTS_COMMON_FIELDS}.is_highlight.label`}
        sx={{ marginTop: '1.5rem' }}
      />
      <BooleanInput color='primary' source='is_active' label={`${COMMON_FIELDS}.status.label`} />
    </SimpleForm>
  )
}

const ProductEdit = (): JSX.Element => {
  const transform: TransformData = useCallback((data) => {
    return {
      ...data,
      slug_th: trim(data.slug_th),
      slug_en: trim(data.slug_en),
    }
  }, [])
  return (
    <EditBase
      title={`${PRODUCTS_COMMON_FIELDS}.edit.title`}
      encType='multipart/form-data'
      keepEmpty={CARD_PROMOTION_FIELDS}
      actions={false}
      listAction={{
        hasShow: false,
        hasBackButton: true,
      }}
      redirect={'show'}
      transform={transform}
    >
      <EditForm />
    </EditBase>
  )
}

export default ProductEdit
